import { jsx } from "@ecopages/jsx/jsx-runtime";
import { withDefaultAriaLabel } from "@/aria";
import { coalesceDefined } from "@/lib/coalesce-defined";
import { cx } from "@/lib/cx";
export function RuiFeed({
  children,
  label,
  class: className,
  aria,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    aria: withDefaultAriaLabel(aria, label),
    role: "feed",
    class: cx("rui-feed", className),
    children
  });
}
export function RuiFeedArticle({
  children,
  posinset,
  setsize,
  labelledBy,
  describedBy,
  tabindex = 0,
  class: className,
  "aria-posinset": ariaPosinset,
  "aria-setsize": ariaSetsize,
  "aria-labelledby": ariaLabelledby,
  "aria-describedby": ariaDescribedby,
  ...props
}) {
  return /* @__PURE__ */jsx("article", {
    ...props,
    class: cx("rui-feed__article", className),
    tabindex,
    "aria-posinset": coalesceDefined(ariaPosinset, posinset),
    "aria-setsize": coalesceDefined(ariaSetsize, setsize),
    "aria-labelledby": coalesceDefined(ariaLabelledby, labelledBy),
    "aria-describedby": coalesceDefined(ariaDescribedby, describedBy),
    children
  });
}
export function RuiFeedArticleHeader({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("header", {
    ...props,
    class: cx("rui-feed__header", className),
    children
  });
}
export function RuiFeedArticleContent({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-feed__content", className),
    children
  });
}
export function RuiFeedArticleActions({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-feed__actions", className),
    children
  });
}
export function RuiFeedByline({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-feed__byline", className),
    children
  });
}
export function RuiFeedBylineBody({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-feed__byline-body", className),
    children
  });
}
export function RuiFeedMeta({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx("rui-feed__meta", className),
    children
  });
}